module.exports = __webpack_public_path__ + "media/images/Ehdot-5c9b7c38bc2125fb8400199ffa1a8116.svg";